module.exports = __webpack_public_path__ + "img/dramadriehoek.fb63e673.png";